/**
 * Available breakpoints, based on the ones bootstrap uses.
 *
 * @type {{DESKTOP: number, TABLET: number, MOBILE: number}}
 */
export const breakpoints = {
    MOBILE: 767,
    TABLET: 991,
    DESKTOP: Infinity,
};

/**
 * Calculates and returns the current breakpoint.
 *
 * @param width
 * @returns {number}
 */
export const getBreakpoint = (width = window.innerWidth) => {
    const { MOBILE, TABLET, DESKTOP } = breakpoints;

    if (width <= MOBILE) {
        return MOBILE;
    }

    if (width <= TABLET) {
        return TABLET;
    }

    return DESKTOP;
};
